"use strict";

const { default: Swal } = require("sweetalert2");
const config = require('../../../../../config/locales_json/packs/private/oferts/oferts.json');
const language = $('body').data("language");
const origin = $('#kt_datatable_oferts_external').data("p-origin");
var kt_datatable_oferts_external = undefined
// Class definition

var OfertsExternalPrivateDatatable = function() {
  // Private functions
  var _init = function() {
    var pathClients = document.location.pathname

    const platformUrl = origin == 0 ? 'https://firstjob.me' : 'https://talentocloud.firstjob.me';

    var datatable = $('#kt_datatable_oferts_external').KTDatatable({
      // datasource definition
      data: {
        type: 'remote',
        source: {
          read: {
            url: pathClients+'/get_external_oferts.json',
            method: 'GET',
            map: function(data) {
              if(data.statusCode) {
                const text = getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "data", "status_code_swalfire_text"], "Lo sentimos!, ");
                Swal.fire({
                  text: text+data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "data", "status_code_swalfire_confirmButtonText"],"Aceptar"),
                  customClass: {
                      confirmButton: "btn btn-fj-purple"
                  }
                });

                return false;
              }

              const totalText = getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "data", "total"], " Total");
              $("#kt_subheader_total").html(data.meta.total + totalText)

              setTimeout(() => {
                $('div#kt_datatable_oferts_external .tp').tooltip('enable');
                $('div#kt_datatable_oferts_external span').tooltip('enable');
              }, 2000);

              return data.data
            }
          },
        },
        search: true,
        pageSize: 10, // display 20 records per page
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true
      },

      // layout definition
      layout: {
          scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
          footer: false, // display/hide footer
      },

      // column sorting
      sortable: true,

      pagination: true,

      search: {
        input: $('#kt_subheader_oferts_external_search_form'),
        delay: 400,
        key: 's'
      },

      toolbar: {
				items: {
					pagination: {
						pageSizeSelect: [5, 10, 20],
					},
				},
			},

      translate: {
        records: {
          processing: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "translate", "records-processing"],'Cargando...'),
          noRecords: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "translate", "records-noRecords"],'No hay publicaciones')
        },
        toolbar: {
          pagination: {
            items: {
              default: {
                first: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "toolbar", "default-first"], 'Primero'),
                prev: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "toolbar", "default-prev"], 'Anterior'),
                next: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "toolbar", "default-next"], 'Siguiente'),
                last: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "toolbar", "default-last"], 'Último'),
                more: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "toolbar", "default-more"], 'Más páginas'),
                input: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "toolbar", "default-input"], 'Página number'),
                select: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "toolbar", "default-select"], 'Selecciona el tamaño de la página')
              },
              info: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "toolbar", "info"], 'Mostrando {{start}} - {{end}} de {{total}} publicaciones')
            }
          }
        }
      },

      // columns definition
      columns: [{
        field: 'title',
        title: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "title", "title"],'Publicaciones'),
        width: 200,
        template: function(data) {
          switch (data.type_work) {
            case "practica":
              var type_work = getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "title", "switch_case_0"],"Práctica, pasantía, internship")
              break;
            case "trabajo":
              var type_work = getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "title", "switch_case_1"],"Trabajo")
              break;
            case "banco_talento":
              var type_work = getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "title", "switch_case_2"],"Banco de Talento")
              break;
            default:
              var type_work = getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "title", "switch_default"],"Sin información")
          }

          var output = '<div class="d-flex align-items-center">\
            <div class="ml-3">\
              <div class="text-dark-75 font-weight-bolder font-size-lg mb-0"><span>'+ data.title +'</span></div>\
              <span class="text-muted font-weight-bold">'+ type_work +' | '+ data.address +'</span>\
            </div>\
          </div>';

          return output;
        }
      },{
        field: 'start_date',
        title: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "postulations", "start_date"],'Inicio'),
        sortable: 'desc',
        type: 'date',
        format: 'DD/MM/YYYY',
        width: 100,
        template: function(row) {
          if(row.start_date) {
            var output = '<div class="font-weight-bolder mb-0">' + _parsedDate(row.start_date) + '</div>';
          } else {
            const outputText = getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "end_date", "output_text"],'No especifíca')
            var output = '<div class="font-weight-bolder mb-0">'+outputText+'</div>';
          }

          return output;
        }
      },{
        field: 'end_date',
        title: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "end_date", "title"],'Término'),
        sortable: 'desc',
        type: 'date',
        format: 'DD/MM/YYYY',
        width: 100,
        template: function(row) {
          if(row.end_date) {
            var output = '<div class="font-weight-bolder mb-0">' + _parsedDate(row.end_date) + '</div>';
          } else {
            const outputText = getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "end_date", "output_text"],'No especifíca')
            var output = '<div class="font-weight-bolder mb-0">'+outputText+'</div>';
          }

          return output;
        }
      },{
        field: 'published_by',
        title: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "published_by", "title"],'Publicado por'),
        template: function(data) {
          var output = '<div class="d-flex align-items-center">\
            <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">' + data.recruiter_first_name + ' ' + data.recruiter_last_name + '</div>\
          </div>';

          return output;
        }
      },
      {
        field: 'Actions',
        title: getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "Actions", "title"],'Acciones'),
        sortable: false,
        width: 130,
        overflow: 'visible',
        autoHide: false,
        template: function(row) {
          var urlEdit = '/admin/clientes/'+row.client_slug+'/ofertas/'+ row.id +'/edit?external=true'

          const editLink = `<a href="${urlEdit}" class="icon tp" data-toggle="tooltip" data-theme="dark" title="${getTranslationValue(config, [language, "OfertsExternalPrivateDatatable", "columns", "Actions", "row_counter_edit_title"], "Validar")}"><i class="fas fa-eye"></i></a>`;

          const actionButtons = `
            ${editLink}
          `;

          const output = `
            <div class="d-flex align-items-center container-actions-table">
              ${!row.is_archived ? actionButtons : ''}
            </div>
          `;

          return output;
        }
      }],
      search: {
        input: $('#kt_subheader_oferts_external_search_form'),
      },
    });

    kt_datatable_oferts_external = datatable
  };

  var _parsedDate = function(date){
    // Extraer año, mes y día de la cadena
    var parts = date.split('T')[0].split('-');
    var year = parts[0];
    var month = parts[1];
    var day = parts[2];

    // Formatear la fecha en el nuevo formato (DD/MM/YYYY)
    return day + '/' + month + '/' + year;
  }

  return {
    // public functions
    init: function() {
        _init();
    },
  };
}();

$(document).ready(function() {
  if($("#kt_datatable_oferts_external").length > 0){
    OfertsExternalPrivateDatatable.init();
  }

});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;

	let currentTranslation;
	let firstIteration = true;

	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {

      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
